export const getDefault = ({ lang }) => {

  const schema = {
    name: 'Cards',
    backgroundColor: '#E6E7E8',
    activeColor: '#E6E7E8',
    textColor: '#000',
    titleColor: '#000',
    title: '',
    data: [
      {
        title: 'Título 1 ',
        href: null,
        content: '\nDescrição 1',
        buttonTitle: lang === 'pt' ? 'saber mais' : 'learn more'
      },
      {
        title: 'Título 2 ',
        href: null,
        content: '\nDescrição 2',
        buttonTitle: lang === 'pt' ? 'saber mais' : 'learn more'
      },
      {
        title: 'Título 3 ',
        href: null,
        content: '\nDescrição 3',
        buttonTitle: lang === 'pt' ? 'saber mais' : 'learn more'
      }
    ]
  }
  return schema
}
